export const visaSuggestionsList = [{
  value: 457,
  text: '457 - Temporary Work (Skilled) Visa'
}, {
  value: 482,
  text: '482 - Temporary Skill Shortage (TSS) Visa'
}, {
  value: 485,
  text: '485 - Temporary Graduate'
}, {
  value: 417,
  text: '417 - Working Holiday'
}, {
  value: 461,
  text: '461 - New Zealand Citizen Family Relationship (Temporary)'
}, {
  value: 402,
  text: '402 - Training and Research Visa'
}, {
  value: 416,
  text: '416 - Special Program Visa'
}, {
  value: 401,
  text: '401 - Temporary Work(Long-stay Activity) Visa'
}, {
  value: 462,
  text: '462 - Work and Holiday'
}, {
  value: 420,
  text: '420 - Entertainment Visa/Temporary Work (Entertainment)'
}, {
  value: 489,
  text: '489 - Skilled - Nominated or Sponsored (Provisional)'
}, {
  value: 407,
  text: '407 - Training'
}, {
  value: 408,
  text: '408 - Temporary Activity'
}, {
  value: 600,
  text: '600 - Visitor Visa'
}];